import React from "react";

import { color } from "minimum-ui/tokens";
import styled from "styled-components";
import { Spinner } from "ui/core";

export interface LoaderProps {
  isLoading?: boolean;
  isUninitialized?: boolean;
  isFetching?: boolean;
}

/**
 * Component for loading state that transitions between two pages of data
 */
const Loader: React.FC<LoaderProps> = ({
  isLoading,
  isUninitialized,
  isFetching,
}) => {
  // Only show during a fetch event, i.e. going between a loaded state to a variation
  // initial load is handled by the skeleton
  const show = isFetching && !isLoading && !isUninitialized;

  if (!show) {
    return null;
  }
  return (
    <LoaderWrapper>
      <Spinner />
    </LoaderWrapper>
  );
};

const LoaderWrapper = styled.div`
  background-color: rgba(255, 255, 255, 0.7);
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: grid;
  place-content: center;
  z-index: 3;
  color: ${color.blue[300]};
  // ignore any reordering
  grid-column: 1 / -1 !important;
`;

export default Loader;
